import React, { useEffect, useState } from 'react';
import {
  adaptGrapheneProductToHybris,
  getYmalRecommendations,
  removeExternalTitle,
} from '../../../products/components/productList/advancedCommerce/getYmalRecommendations';
import ProductCard from './ProductCard';
import { initProductCarousels } from './productCarousel';

const {
  locale: { currentCurrency },
} = window.inlineGlobalConfig || {};

export const CarouselContent = () => {
  const [carouselProducts, setCarouselProducts] = useState();
  const [languageCulture, setLanguageCulture] = useState('en-GB');

  const [isInitialized, setIsInitialized] = useState(false);

  useEffect(() => {
    const fetchYmal = async () => {
      try {
        const response = await getYmalRecommendations('', '', window.location.href, 'homepage_recs_v2');

        setLanguageCulture(response.header.language_culture);

        const productList = response?.elements?.homepage_recs_v2?.products?.results || [];

        if (productList.length > 0) {
          const adaptedProducts = productList.map(gProduct =>
            adaptGrapheneProductToHybris(gProduct.item, currentCurrency)
          );

          setCarouselProducts(adaptedProducts);
        } else {
          removeExternalTitle();
        }
      } catch (error) {
        removeExternalTitle();
        console.error('❌ YMAL FETCH ERROR:', error);
      }
    };

    fetchYmal();
  }, []);

  // eslint-disable-next-line consistent-return
  useEffect(() => {
    if (carouselProducts && carouselProducts.length > 0) {
      const timer = setTimeout(() => {
        initProductCarousels();
        setIsInitialized(true);
      }, 200);

      return () => clearTimeout(timer);
    }
  }, [carouselProducts]);

  return (
    <div
      className={`product-carousel-standard product-carousel pcarousel gallery ${isInitialized ? 'initialized' : ''}`}
    >
      {carouselProducts?.map(product => (
        <ProductCard key={product.id} product={product} languageCulture={languageCulture} />
      ))}
    </div>
  );
};
